import { axiosInstance } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypePatchOwnerSupplierParams, TypePatchOwnerSupplierResponse } from '~/types/vender.types';

/**
 * [화주사 정보 관리 > 공급사 관리] 공급사 정보 수정
 */
const usePatchOwnerSupplier = () => {
  const endPoint = '/api-owner/owner-supplier';

  const patchOwnerSupplier = async (params: TypePatchOwnerSupplierParams) => {
    return axiosInstance
      .patch<TypePatchOwnerSupplierResponse>(endPoint, params)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { patchOwnerSupplier };
};

export default usePatchOwnerSupplier;
